/* jshint esversion: 6 */
import router from "../index";
import store from "../../store";
import NProgress from "nprogress"; // progress bar
// import "@/components/NProgress/nprogress.less"; // progress bar custom style
import { setDocumentTitle } from "@/utils";
import config from "@/configs/defaultConfigs";
import moment from "moment";

const actualConfig = config.Z || config;

NProgress.configure({ showSpinner: false }); // NProgress Configuration
router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  // 自动修改页面标题
  to.meta && typeof to.meta.title !== "undefined" && setDocumentTitle(`${to.meta.title} - ${actualConfig.title}`);
  // 判断浏览器是否支持
  if (typeof Storage !== "undefined") {
    // 检查token是否存在及是否过期
    const token = localStorage.getItem(actualConfig.ACCESS_TOKEN);
    const tokenTime = localStorage.getItem(actualConfig.ACCESS_TOKEN_TIMEOUT);
    if (token && tokenTime && moment(tokenTime, moment.ISO_8601).isAfter(moment())) {
      if (to.path === "/login") {
        // 有token且未过期，访问登录页面直接跳转到首页
        next({ path: actualConfig.DEFAULT_INDEX });
        NProgress.done();
      } else {
        if (!router.hasRoute("error")) {
          store
            .dispatch("INIT_INFO")
            .then((res) => {
              store
                .dispatch("GenerateRoutes")
                .then((addRouters) => {
                  // 根据roles权限生成可访问的路由表 动态添加可访问路由表
                  _.cloneDeep(addRouters).forEach((route) => {
                    if (!router.hasRoute(route)) router.addRoute(route);
                  });
                  const redirect = decodeURIComponent(from.query.redirect || to.path);
                  if (to.path === redirect) {
                    // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                    next({ ...to, replace: true });
                  } else {
                    // 跳转到目的路由
                    next({ path: redirect });
                  }
                })
                .catch((err) => {
                  // str 参数即为 debug 信息
                  // console.error('process.env.NODE_ENV1', process.env.NODE_ENV, process.env)
                  if (process.env.NODE_ENV != "production") console.error(err);
                  store.dispatch("Logout").then(() => {
                    next({ path: "/login", query: { redirect: to.fullPath } });
                  });
                });
              // 登录后进行 websocket 链接
              // store.dispatch('WEBSOCKET_CONNECT', { state: store.state, dispatch: store.dispatch })
            })
            .catch((err) => {
              // console.error('process.env.NODE_ENV2', process.env.NODE_ENV, process.env)
              if (process.env.NODE_ENV != "production") console.error(err);
              this.$Notice.error({
                title: "错误",
                desc: "请求用户信息失败，请重试",
              });
              store.dispatch("Logout").then(() => {
                next({ path: "/login", query: { redirect: to.fullPath } });
              });
            });
        } else {
          next();
        }
      }
    } else {
      if (actualConfig.WHITE_LIST.includes(to.name)) {
        // 在免登录白名单，直接进入
        next();
      } else {
        store.dispatch("INIT_CLIENT_ID").then((clientId) => {
          // console.log('INIT_CLIENT_ID', clientId)
          store
            .dispatch("LOGIN_CHECK", {...to.query, clientId})
            .then(() => {
              const redirect = decodeURIComponent(from.query.redirect || to.path);
              if (to.path === redirect) {
                next({ ...to, replace: true });
              } else {
                // 跳转到目的路由
                next({ path: redirect });
              }
            })
            .catch((err) => {
              // 非白名单 切无登录权限 去登录页面
              next({ path: "/login", query: { redirect: to.fullPath } });
              NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
            });
        });
      }
    }
  } else {
    this.$Message.error("对不起, 本系统不支持您当前使用的浏览器，建议使用FireFox/Chrome/360浏览器（极速模式）进行访问...");
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});

export default router;
